'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageComposer = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _reactAutosizeTextarea = require('react-autosize-textarea');

var _reactAutosizeTextarea2 = _interopRequireDefault(_reactAutosizeTextarea);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageComposer = exports.MessageComposer = function MessageComposer(_ref) {
  var value = _ref.value,
      border = _ref.border,
      disabled = _ref.disabled,
      _onChange = _ref.onChange,
      onSend = _ref.onSend;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('message-composer', disabled && 'is-disabled', border && 'has-border') },
    _react2.default.createElement(_reactAutosizeTextarea2.default, {
      className: 'composer-input',
      disabled: disabled
      // Have to use style here because the library adds it itself.
      , style: { resize: 'none' },
      placeholder: 'Write your message here..',
      value: value,
      onChange: function onChange(e) {
        return _onChange(e.target.value);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.charCode === 13 && !e.shiftKey) {
          onSend();
          setTimeout(function () {
            return _onChange('');
          }, 0);
        }
      }
    }),
    _react2.default.createElement(
      'div',
      { className: 'actions' },
      _react2.default.createElement(
        'button',
        {
          className: 'button is-icon-only',
          disabled: !value || !value.trim() || disabled,
          onClick: onSend,
          title: 'Send message'
        },
        _react2.default.createElement(_Icon2.default, { material: true, name: 'send', className: 'send-icon' })
      )
    )
  );
};

MessageComposer.propTypes = {
  value: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onSend: _propTypes2.default.func
};

MessageComposer.defaultProps = {
  onChange: _noop2.default,
  onSend: _noop2.default
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/MessageComposer/index.js
// module id = 619
// module chunks = 0